import React from 'react';

function InputText({ placeholder, name, value, onChange }) {
  return (
    <div className='w-full xl:w-1/2 flex flex-col justify-center mx-1 text-sm xl:text-base rounded-xl'>
      <input
        className='text-center w-full h-full p-1 rounded-xl border border-GrisOscuro'
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        type='text'
      />
    </div>
  );
}

export default InputText;
